import React from "react";
import { IDonorDonationDTO } from "../../../../../services/bexWISE/donorDataService/IDonorDataService";
import { IDonorDTO } from "../../../../../types/IDonorDTO";
import ProfileSection from "./ProfileSection";
import HistoricalResultsSection from "./HistoricalResultsSection";
import { Col, Row, Stack } from "react-bootstrap";
import LocationSection from "./LocationSection";

interface PhysicalExamDesktopProps {
   loading: boolean;
   profileData: IDonorDTO;
   displayDonorData: IDonorDonationDTO[];
   yearsValues: number[];
   selectedYear: number;
   setSelectedYear: Function;
   selectedDate: string;
   setSelectedDate: Function;
   lastDonation: IDonorDonationDTO | null;
}

const PhysicalExamsDesktopView: React.FC<PhysicalExamDesktopProps> = ({
   loading,
   profileData,
   displayDonorData,
   yearsValues,
   selectedYear,
   setSelectedYear,
   selectedDate,
   setSelectedDate,
   lastDonation,
}) => {
   return (
      <div>
         <Stack gap={2}>
            <Row>
               <Col sm={9}>
                  <ProfileSection
                     loading={loading}
                     profileData={profileData}
                     weight={lastDonation ? lastDonation.physicalExam.weight : 0}
                     height={lastDonation ? lastDonation.physicalExam.height : 0}
                  />
               </Col>
               <Col sm={3}>
                  <LocationSection
                     loading={loading}
                     lastDonorData={lastDonation}
                  />
               </Col>
            </Row>
            <HistoricalResultsSection
               loading={loading}
               yearsValues={yearsValues}
               selectedYear={selectedYear}
               setSelectedYear={setSelectedYear}
               selectedDate={selectedDate}
               setSelectedDate={setSelectedDate}
               displayDonorData={displayDonorData}
            />
         </Stack>
      </div>
   );
};

export default PhysicalExamsDesktopView;
